import React from "react";

import Icon from "Common/Icon";

import { bem } from "./utils";

const ClickableFilename = ({ htmlFor, filename }) => (
  <label type="text" className={bem("Filename")} htmlFor={htmlFor}>
    {filename || (
      <>
        <Icon icon="upload" mr={1} flavor="solid" /> Select a file...
      </>
    )}
  </label>
);

export default ClickableFilename;
